import * as React from 'react'

import type { Reviewees } from 'modules/reviews/lib/types'

import type Review from '../store/models/v2/Review'

export const RevieweesContext = React.createContext<{
  fetchReviewees: () => void
  loading: boolean
  reviewees: Reviewees
  reviewModel: Review | null | undefined
}>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  fetchReviewees: () => {},
  loading: true,
  reviewees: {},
  reviewModel: undefined,
})
